// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__I201i","perdeu":"LoginForm_perdeu__0XHTq","cadastro":"LoginForm_cadastro__BBT1I","subtitle":"LoginForm_subtitle__EQ37E"};